import React, { useEffect, useState } from "react";
import { Paper, Typography, Box } from "@mui/material";
import { Form, Button, Input, Select, message, Modal } from "antd";
import {
  UserOutlined,
  MailOutlined,
  PhoneOutlined,
  MessageOutlined,
  LockOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { cachedGet } from "../../services/api";

const Register_Dialog = ({ open, onClose }) => {
  const [selectOptions_prov, setSelectOptions_prov] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { Option } = Select;
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("username", values.username);
    formData.append("lastName", values.lastName);
    formData.append("email", values.email);
    formData.append("password", values.password);
    formData.append("phone_number", values.phone_number);
    formData.append("Id_line", values.Id_line);
    formData.append("province", values.province);
    try {
      const registerResponse = await fetch(
        "https://subd.checkkonproject.com/api/register",
        {
          method: "POST",
          body: formData,
        }
      );
      if (registerResponse.ok) {
        message.success("สมัครสมาชิกเสร็จสิ้น");
        const loginResponse = await fetch(
          "https://subd.checkkonproject.com/api/login",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              email: values.email,
              password: values.password,
            }),
          }
        );
        if (loginResponse.ok) {
          const loginData = await loginResponse.json();
          localStorage.setItem("access_token", loginData.message);
          onClose();
          navigate(`/`);
          window.location.reload();
        } else {
          message.error("เกิดข้อผิดพลาดในการล็อกอิน");
        }
      } else if (registerResponse.status === 409) {
        message.error("อีเมลนี้มีการใช้งานแล้ว");
      } else {
        message.error("เกิดข้อผิดพลาดในการสมัครสมาชิก");
      }
    } catch (error) {
      console.error("Error registering user:", error);
      message.error("เกิดข้อผิดพลาดในการสมัครสมาชิก");
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  useEffect(() => {
    let isMounted = true;
    const fetchProvinces = async () => {
      try {
        const typeCodes = await cachedGet("/Province_request", {}, 300000);
        if (!isMounted || !Array.isArray(typeCodes)) return;
        const options = typeCodes.map((code) => (
          <Option key={code.id} value={code.id}>
            {code.prov_name}
          </Option>
        ));
        setSelectOptions_prov(options);
      } catch (error) {
        console.error("Error:", error);
      }
    };
    fetchProvinces();
    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        const firstInput = document.querySelector('input[name="username"]');
        if (firstInput) firstInput.focus();
      }, 200);
    }
  }, [open]);

  const labelStyle = {
    fontSize: "16px",
    fontWeight: 600,
    color: "#334155",
  };

  const inputStyle = {
    borderRadius: "12px",
    height: "48px",
    padding: "10px 16px",
    backgroundColor: "#ffffff",
    color: "#1e293b",
    fontSize: "16px",
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={680}
      destroyOnClose
      centered
    >
      <Box sx={{ textAlign: "center", pt: 0.5, pb: 0.5 }}>
        <div className="container-title" style={{ marginBottom: 4 }}>
          สมัครสมาชิก
        </div>
        <Typography variant="body2" sx={{ color: "#64748b", mb: 1 }}>
          ร่วมเป็นส่วนหนึ่งของเครือข่ายเฝ้าระวังข้อมูลผิดพลาดสำหรับผู้บริโภคภาคใต้
        </Typography>
      </Box>
      <Paper
        elevation={0}
        className="form-container"
        style={{ padding: "12px 16px 4px" }}
      >
        <Form
          form={form}
          layout="vertical"
          name="form_register"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          style={{
            maxWidth: "100%",
          }}
          autoComplete="off"
        >
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
              gap: 2,
            }}
          >
            <Form.Item
              label={<span style={labelStyle}>ชื่อ</span>}
              name="username"
              rules={[{ required: true, message: "กรุณาเพิ่มชื่อ!" }]}
              style={{ marginBottom: 8 }}
            >
              <Input
                style={inputStyle}
                size="large"
                placeholder="ระบุชื่อจริง"
                prefix={<UserOutlined style={{ color: "#94a3b8" }} />}
              />
            </Form.Item>
            <Form.Item
              label={<span style={labelStyle}>นามสกุล</span>}
              name="lastName"
              rules={[{ required: true, message: "กรุณาเพิ่มนามสกุล!" }]}
              style={{ marginBottom: 8 }}
            >
              <Input
                style={inputStyle}
                size="large"
                placeholder="ระบุนามสกุล"
              />
            </Form.Item>
          </Box>

          <Form.Item
            label={<span style={labelStyle}>อีเมล</span>}
            name="email"
            rules={[{ required: true, message: "กรุณาเพิ่มอีเมล!" }]}
            style={{ marginBottom: 12 }}
          >
            <Input
              style={inputStyle}
              size="large"
              placeholder="example@email.com"
              prefix={<MailOutlined style={{ color: "#94a3b8" }} />}
            />
          </Form.Item>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
              gap: 2,
            }}
          >
            <Form.Item
              label={<span style={labelStyle}>รหัสผ่าน</span>}
              name="password"
              rules={[{ required: true, message: "กรุณาเพิ่มรหัสผ่าน!" }]}
              style={{ marginBottom: 8 }}
            >
              <Input.Password
                style={inputStyle}
                size="large"
                placeholder="กำหนดรหัสผ่าน"
                prefix={<LockOutlined style={{ color: "#94a3b8" }} />}
              />
            </Form.Item>
            <Form.Item
              label={<span style={labelStyle}>รหัสผ่านยืนยัน</span>}
              name="Confirm Password"
              dependencies={["password"]}
              rules={[
                { required: true, message: "กรุณาเพิ่มรหัสผ่านยืนยัน!" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("รหัสผ่านไม่ตรงกัน!"));
                  },
                }),
              ]}
              style={{ marginBottom: 8 }}
            >
              <Input.Password
                style={inputStyle}
                size="large"
                placeholder="ยืนยันรหัสผ่านอีกครั้ง"
                prefix={<LockOutlined style={{ color: "#94a3b8" }} />}
              />
            </Form.Item>
          </Box>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
              gap: 2,
              mt: 0.5,
            }}
          >
            <Form.Item
              label={<span style={labelStyle}>เบอร์ติดต่อ (หากไม่มีให้ใส่ - )</span>}
              name="phone_number"
              rules={[{ required: true, message: "กรุณาเพิ่มเบอร์ติดต่อ!" }]}
              style={{ marginBottom: 8 }}
            >
              <Input
                style={inputStyle}
                size="large"
                placeholder="เช่น 0812345678 หรือ -"
                prefix={<PhoneOutlined style={{ color: "#94a3b8" }} />}
              />
            </Form.Item>
            <Form.Item
              label={<span style={labelStyle}>ไอดีไลน์ (หากไม่มีให้ใส่ - )</span>}
              name="Id_line"
              rules={[{ required: true, message: "กรุณาเพิ่มไอดีไลน์!" }]}
              style={{ marginBottom: 8 }}
            >
              <Input
                style={inputStyle}
                size="large"
                placeholder="ระบุ LINE ID หรือ -"
                prefix={<MessageOutlined style={{ color: "#94a3b8" }} />}
              />
            </Form.Item>
          </Box>

          <Form.Item
            label={<span style={labelStyle}>จังหวัดที่สังกัด</span>}
            name="province"
            rules={[{ required: true, message: "กรุณาเลือกจังหวัดที่สังกัด!" }]}
            style={{ marginBottom: 20, marginTop: 4 }}
          >
            <Select
              allowClear
              size="large"
              placeholder="เลือกจังหวัดที่สังกัด"
              showSearch
              optionFilterProp="children"
            >
              {selectOptions_prov}
            </Select>
          </Form.Item>

          <Form.Item style={{ marginBottom: 8 }}>
            <Button
              shape="round"
              type="primary"
              htmlType="submit"
              loading={loading}
              className="form-button"
            >
              ลงทะเบียน
            </Button>
          </Form.Item>
        </Form>
      </Paper>
    </Modal>
  );
};

export default Register_Dialog;
